export default __webpack_public_path__ + "static/media/s2.47d22f54.jpg";